<template>
  <div class="onboarding-wrapper">
    <slot></slot>
    <div 
      v-if="isActive && currentElement" 
      class="onboarding-overlay" 
      :style="overlayStyle"
      @click="skipTutorial"
    >
      <div
        class="highlight-cutout"
        :style="cutoutStyle"
        @click.stop
      ></div>
    </div>
    <OnboardingTooltip
      v-if="isActive && currentStep && currentElement"
      :visible="true"
      :title="currentStep.title"
      :message="currentStep.message"
      :position="currentStep.position"
      :target-element="currentElement"
      :show-previous="currentStepIndex > 0"
      :is-last-step="isLastStep"
      :skippable="true"
      @previous="previousStep"
      @next="nextStep"
      @skip="skipTutorial"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import OnboardingTooltip from "./OnboardingTooltip.vue";
import { onboardingService } from "@/services/OnboardingService";

export default {
  name: "OnboardingWrapper",
  components: {
    OnboardingTooltip,
  },
  computed: {
    ...mapState("onboarding", ["isActive", "currentStepIndex", "steps"]),
    
    currentStep() {
      if (
        !this.steps ||
        !this.steps.length ||
        this.currentStepIndex >= this.steps.length
      ) {
        return null;
      }
      return this.steps[this.currentStepIndex];
    },
    
    currentElement() {
      if (!this.currentStep || !this.currentStep.elementSelector) return null;
      
      const el = document.querySelector(this.currentStep.elementSelector);
      
      if (!el && this.isActive) {
        console.warn(
          `Onboarding Warning: Could not find element "${this.currentStep.elementSelector}" for step ${this.currentStepIndex}.`
        );
      }
      
      return el;
    },
    
    isLastStep() {
      return this.currentStepIndex === this.steps.length - 1;
    },
    
    overlayStyle() {
      return {
        opacity: this.isActive && this.currentElement ? 0.5 : 0,
        pointerEvents: this.isActive && this.currentElement ? 'auto' : 'none',
      };
    },
    
    cutoutStyle() {
      if (!this.currentElement) return {};
      
      const rect = this.currentElement.getBoundingClientRect();
      const padding = 4;
      
      return {
        top: `${rect.top - padding}px`,
        left: `${rect.left - padding}px`,
        width: `${rect.width + padding * 2}px`,
        height: `${rect.height + padding * 2}px`,
      };
    },
  },
  
  methods: {
    nextStep() {
      onboardingService.next();
    },
    
    previousStep() {
      onboardingService.previous();
    },
    
    skipTutorial() {
      onboardingService.skip();
    },
  },
};
</script>

<style scoped>
.onboarding-wrapper {
  position: relative;
  flex: 1;
  width: 100%;
  min-width: 0;
}

.onboarding-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  z-index: 9998;
  cursor: pointer;
}

.highlight-cutout {
  position: fixed;
  background: transparent;
  border: 2px solid #ff7222;
  border-radius: 4px;
  z-index: 9999;
  transition: all 0.3s ease;
  pointer-events: none;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5), 0 0 15px rgba(255, 114, 34, 0.3);
}
</style>


// WEBPACK FOOTER //
// src/components/onboarding/OnboardingWrapper.vue